import { NavLink, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Nav = styled.nav`
  display: flex;
  gap: 16px;
  a { color: #0f172a; text-decoration: none; font-weight: 600; }
  a.active { color: #0ea5e9; }
`;

export default function Navbar() {
  const { t } = useTranslation();
  const { lng } = useParams();

  return (
    <Nav aria-label="Main Navigation">
  <NavLink className={({ isActive }) => isActive ? 'active' : undefined} to={`/${lng}`}>{t('nav.home')}</NavLink>
  <NavLink className={({ isActive }) => isActive ? 'active' : undefined} to={`/${lng}/quote`}>{t('nav.quote')}</NavLink>
  <NavLink className={({ isActive }) => isActive ? 'active' : undefined} to={`/${lng}/blog`}>{t('nav.blog')}</NavLink>
  <NavLink className={({ isActive }) => isActive ? 'active' : undefined} to={`/${lng}/contact`}>{t('nav.contact')}</NavLink>
    </Nav>
  );
}
